// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"3beddc4f","977":"b354189c"}[chunkId] + ".chunk.js";
};